/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Fit_ViewInputs */

const cs_workflow_fit_view = /** @type {(inputs: Workflow_Fit_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přizpůsobit pohled`)
};

const en_workflow_fit_view = /** @type {(inputs: Workflow_Fit_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fit to view`)
};

/**
* | output |
* | --- |
* | "Fit to view" |
*
* @param {Workflow_Fit_ViewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_fit_view = /** @type {((inputs?: Workflow_Fit_ViewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Fit_ViewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_fit_view(inputs)
	return cs_workflow_fit_view(inputs)
});